import { configureStore } from '@reduxjs/toolkit'
import rootReducer from '../Base/rootReducer';

const store = configureStore({ reducer: rootReducer })
export default store;
